export default '/build/c262e007.svg'